import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame", "year"]
  static values = { url: String }

  update() {
    const year = this.yearTarget.value
    if (!year) return

    this.frameTargets.forEach((frame) => {
      const quarter = frame.dataset.quarter
      const compositionIndex = frame.dataset.compositionIndex
      const container = document.getElementById(
        `hkn_items_for_composition_${compositionIndex}`,
      )
      const subsidizedShare = this.#computeSubsidizedShare(container)

      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set("year", year)
      url.searchParams.set("quarter", quarter)
      url.searchParams.set("subsidized_share", subsidizedShare)

      frame.src = url.toString()
    })
  }

  #computeSubsidizedShare(container) {
    if (!container) return 0

    let total = 0

    container.querySelectorAll("fieldset").forEach((fieldset) => {
      const destroyCheckbox = fieldset.querySelector(
        'input[name*="_destroy"][type="checkbox"]',
      )
      if (destroyCheckbox?.checked) return

      const applySubsidyCheckbox = fieldset.querySelector(
        'input[name*="apply_subsidy"][type="checkbox"]',
      )
      const shareInput = fieldset.querySelector('input[name*="[share]"]')

      if (applySubsidyCheckbox?.checked && shareInput) {
        total += parseFloat(shareInput.value) || 0
      }
    })

    container.querySelectorAll("[data-hkn-item]").forEach((item) => {
      if (item.querySelector("fieldset")) return

      if (item.dataset.applySubsidy === "true") {
        total += parseFloat(item.dataset.share) || 0
      }
    })

    return total
  }
}
